// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rg-2";
export var chatLink = "_rg-0";
export var chatText = "_rg-1";